// 공지 본문(TipTap 에디터가 만든 HTML) 렌더링용 sanitize.
//
// 공지 본문은 서버에 HTML 그대로 저장되고 상세 화면에서 dangerouslySetInnerHTML 로 그려진다.
// 렌더링 직전에 DOMPurify 로 스크립트·이벤트 핸들러·javascript: URL 을 걷어낸다.
// 에디터 기능은 DOMPurify 기본 허용 목록으로 대부분 보존된다:
//   글자 색/정렬/이미지 크기(style), 형광펜(mark + data-color), 이미지(img, data: 포함), 링크(a)
// 기본 목록에 없는 것만 추가로 허용한다:
//   유튜브 임베드(iframe) — src 가 유튜브 embed 주소일 때만 남긴다
//   링크 새 창 열기(target) — target 이 있으면 rel="noopener noreferrer" 를 보장한다
import DOMPurify from 'dompurify';

const YOUTUBE_EMBED_SRC = /^https:\/\/(www\.)?(youtube\.com|youtube-nocookie\.com)\/embed\//;

DOMPurify.addHook('uponSanitizeElement', (node, data) => {
  if (data.tagName === 'iframe' && !YOUTUBE_EMBED_SRC.test(node.getAttribute('src') || '')) {
    node.parentNode?.removeChild(node);
  }
});

DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A' && node.hasAttribute('target')) {
    node.setAttribute('rel', 'noopener noreferrer nofollow');
  }
});

export function sanitizeNoticeHtml(html) {
  return DOMPurify.sanitize(html || '', {
    ADD_TAGS: ['iframe'],
    ADD_ATTR: ['target', 'allowfullscreen', 'frameborder', 'allow'],
  });
}
